var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.html';
var html = "<div class=\"container no-padding\"><div class=\"row no-padding\"><div class=col-sm-12><zcs-campaigns-list project=$ctrl.project filters=$ctrl.filters></zcs-campaigns-list></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.html
// module id = 1409
// module chunks = 0